import React, { useRef } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setIsLogin } from "../../redux/actions/roleAction";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profileData } = useSelector((state) => state.profileReducer);
  const toast = useRef(null);

  const handleLogout = () => {
    toast.current.show({ severity: "success", summary: "Logout Successfully" });
    setTimeout(async () => {
      navigate("/");
      dispatch(setIsLogin(false));
    }, 1000);
  };

  const handleProfile = () => {
    navigate("/profile-setting");
    dispatch(setIsLogin(true));
  };
  const handleChangePassword = () => {
    navigate("/profile-setting/ChangePassword");
    dispatch(setIsLogin(true));
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="navbar-cls-add-custom">
        <Navbar collapseOnSelect expand="lg" className="navbar-header-edit">
          <Container fluid>
            <Navbar.Brand href="#home" className="logo-react-bootstrap">
              The Loop
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ms-auto align-items-center in-one-line-responsive-cls-add">
                <div className="notification-cls">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="me-3"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M21.6001 15.15L19.5001 13.2V9.75C19.5001 5.85 16.6501 2.7 12.7501 2.25V0.75H11.2501V2.25C7.50012 2.7 4.50012 5.85 4.50012 9.75V13.2L2.40012 15.15C2.25012 15.3 2.10012 15.45 2.25012 15.75V18C2.25012 18.45 2.55012 18.75 2.85012 18.75H8.25012C8.25012 20.85 9.90012 22.5 12.0001 22.5C14.1001 22.5 15.7501 20.85 15.7501 18.75H21.0001C21.4501 18.75 21.7501 18.45 21.7501 18.15V15.75C21.7501 15.6 21.6001 15.3 21.6001 15.15ZM12.0001 21C10.8001 21 9.75012 19.95 9.75012 18.75H14.2501C14.2501 19.95 13.2001 21 12.0001 21ZM20.2501 17.25H3.75012V16.05L5.70012 13.95C5.85012 13.95 6.00012 13.65 6.00012 13.5V9.75C6.00012 6.45 8.70012 3.75 12.0001 3.75C15.3001 3.75 18.0001 6.45 18.0001 9.75V13.5C18.0001 13.65 18.1501 13.95 18.1501 14.1L20.2501 16.05V17.25Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div className="profile-img-cls">
                  <img
                    src={
                      profileData?.profile_pic
                        ? profileData?.profile_pic
                        : require("../../assets/defaultImg.png")
                    }
                    alt="profile"
                  />
                </div>
                <div className="dropdown-cls-all-subover">
                  <NavDropdown
                    title={`${profileData?.first_name} ${profileData?.last_name}`}
                    id="basic-nav-dropdown"
                  >
                    <NavDropdown.Item onClick={handleChangePassword}>
                      Change Password
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={handleProfile}>
                      Profile
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item onClick={handleLogout}>
                      Logout
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default Header;
